// extracted by mini-css-extract-plugin
export default {"container":"styles_container__xK58k","menu":"styles_menu__FA9xg","copyrights":"styles_copyrights__vh21K","copyCompanyName":"styles_copyCompanyName__As01p"};